import { environment } from "src/environments/environment";

export const grievanceServerUrl = environment.GRIEVANCE_URL; //for demo
//  export const grievanceServerUrl = "https://lotterybackendprod.mhada.gov.in/"; //for production

// export const grievanceServerUrl="http://192.168.1.116:48080/"
// export const grievanceServerUrl="http://103.199.116.11:48080/"
